import ModalController from './index';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/runtime';

const mapStateToProps = state => ({
  runtime: state.runtime,
  hasSubmittedMaryMagicSurvey: state.maryMagicSurvey.hasSubmittedMaryMagicSurvey,
  login: state.login,
});

const mapDispatchToProps = dispatch => ({
  closeModal: modalId => dispatch(hideModal(modalId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalController);
